import { userHasRole } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasRole(user, ["sysadmin"]);
  },
};
